import { Navigate } from "react-router-dom";
import { ISection, IUser } from "../../type";
import { Preloader } from "../Preloader";

interface IProps {
  user: IUser | false | "not_set";
  sections?: ISection[];
  children: React.ReactElement;
}

export const ProtectedAuthRoute = (props: IProps) => {
  // Пока идет первичная инициализация — показываем логотип.
  // Как только `user` стал false (нет сессии) — редиректим на логин.
  if (props.user === "not_set") return <Preloader />;
  if (props.user === false) return <Navigate to="/login" />;

  if (!props.user.paid_status) {
    return <Navigate to="/unpayment" />;
  }

  if (!props.sections) {
    return <Preloader />;
  }

  return props.children;
};
